import { SearchOff } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import { FC } from 'react';

interface TableNoResultPlaceholderProps {
  title?: string;
  subTitle?: string;
}

export const TableNoResultPlaceholder: FC<TableNoResultPlaceholderProps> = ({
  title = t('general.table.noResults.title'),
  subTitle = t('general.table.noResults.subTitle'),
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <SearchOff sx={{ width: 46, height: 46, mb: 3 }} color='primary' />
      <Typography variant='h6'>{title}</Typography>
      <Typography variant='body2' sx={{ color: 'text.secondary' }}>
        {subTitle}
      </Typography>
    </Box>
  );
};
